import {
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import Button from 'components/Button/Button';
import { NOTIFICATIONS_DEFAULT_SETTINGS } from 'constants/notifications-default-settings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { modifyNotificationSetting } from 'store/notifications/actions/notification-settings.actions';
import { selectModifiedNotificationSettings } from 'store/notifications/selectors/notification-settings.selectors';
import { selectSelectedProjectNotificationSettings } from 'store/notifications/selectors/project-notification-settings.selectors';
import { saveNotificationSettingsOfBusiness } from 'store/notifications/thunks/saveNotificationSettingsOfBusiness.thunk';

export const CardAlarms = () => {
  const dispatch = useDispatch();

  const modifiedNotificationSettings = useSelector(
    selectModifiedNotificationSettings
  );

  const alarmSettingsOfBusiness = useSelector(
    selectSelectedProjectNotificationSettings
  );

  const handleNotificationPeriodChannelChange = (toggledValue) => {
    const currentPeriodChannelValue =
      effectiveAlarmNotificationSettings[toggledValue];

    dispatch(
      modifyNotificationSetting({
        attribute: toggledValue,
        value: !currentPeriodChannelValue,
      })
    );
  };

  const { t } = useTranslation('common');

  //   const handleAlarmsStartDateRangeChange = () => {};

  const alarmExpirationPeriodValues = [
    {
      value: 'ALARM_CARDS_EXPIRATION_MONTHS_2',
      name: t('cards-and-competencies.alarm_period_2_months'),
    },
    {
      value: 'ALARM_CARDS_EXPIRATION_MONTHS_1',
      name: t('cards-and-competencies.alarm_period_1_month'),
    },
    {
      value: 'ALARM_CARDS_EXPIRATION_DAYS_14',
      name: t('cards-and-competencies.alarm_period_2_weeks'),
    },
    {
      value: 'ALARM_CARDS_EXPIRATION_DAYS_7',
      name: t('cards-and-competencies.alarm_period_1_week'),
    },
    {
      value: 'ALARM_CARDS_EXPIRATION_DAYS_0',
      name: t('cards-and-competencies.alarm_period_due_date'),
    },
  ];

  const effectiveAlarmNotificationSettings = {
    ...NOTIFICATIONS_DEFAULT_SETTINGS.ALARMS,
    ...alarmSettingsOfBusiness,
    ...modifiedNotificationSettings,
  };

  return (
    <>
      <Typography>
        {t('project.employee_card_alarms_before_expiration_date')}:
      </Typography>
      {alarmExpirationPeriodValues.map((periodValue) => (
        <div style={{ marginTop: '20px' }} key={periodValue.value}>
          <Typography>{periodValue.name}</Typography>

          <FormControlLabel
            required
            control={
              <Checkbox
                color="default"
                checked={
                  effectiveAlarmNotificationSettings[
                    `${periodValue.value}_APPLICATION`
                  ]
                }
                onChange={() =>
                  handleNotificationPeriodChannelChange(
                    `${periodValue.value}_APPLICATION`
                  )
                }
              />
            }
            label={t('cards-and-competencies.application_alarm')}
          />

          <FormControlLabel
            required
            control={
              <Checkbox
                color="default"
                checked={
                  effectiveAlarmNotificationSettings[
                    `${periodValue.value}_EMAIL`
                  ]
                }
                onChange={() =>
                  handleNotificationPeriodChannelChange(
                    `${periodValue.value}_EMAIL`
                  )
                }
              />
            }
            label={t('cards-and-competencies.email_alarm')}
          />

          <FormControlLabel
            required
            control={
              <Checkbox
                color="default"
                checked={
                  effectiveAlarmNotificationSettings[`${periodValue.value}_SMS`]
                }
                onChange={() =>
                  handleNotificationPeriodChannelChange(
                    `${periodValue.value}_SMS`
                  )
                }
                disabled={
                  periodValue.value !== 'ALARM_CARDS_EXPIRATION_DAYS_14' &&
                  periodValue.value !== 'ALARM_CARDS_EXPIRATION_DAYS_0'
                }
              />
            }
            label={t('cards-and-competencies.sms_alarm')}
          />

          <Divider></Divider>
        </div>
      ))}
      <div style={{ textAlign: 'right', marginRight: '20px' }}>
        <Button
          style={{ marginTop: '20px' }}
          disabled={!Object.keys(modifiedNotificationSettings).length > 0}
          color="dark"
          elevated
          onClick={() => dispatch(saveNotificationSettingsOfBusiness())}
        >
          {t('project.save_alarm_settings')}
        </Button>
      </div>
      {/* <div>
        <Typography>Hälytyksien tiheys:</Typography>
        <TextInput
          displayEmpty
          fullWidth
          id="allowance-type-select"
          label={'Hälytyksien aloitus voimassaolon päättymiseen'}
          onChange={(e) => handleAlarmsStartDateRangeChange(e.target.value)}
          select
          shrink
          value={alarmStartValues[0].value}
        >
          {alarmStartValues.map((item) => (
            <MenuItem
              //   className={classes.menuItem}
              key={item.value}
              value={item.value}
            >
              {item.name}
            </MenuItem>
          ))}
        </TextInput>
      </div> */}
    </>
  );
};
